import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';

import { copyToClipboard, IconModule } from '@hglobal/fin-ui';
import { TranslateService } from '@ngx-translate/core';

import { ButtonComponent, InfoDialogContentComponent } from '@iw/common';
import { GlobalToastService } from '@iw/core/services';

import { WithdrawalStore } from '../../withdrawal.store';

export type InfoDialogStatus = 'pending' | 'succeeded' | 'failed';

@Component({
  selector: 'iw-withdrawal-info-dialog',
  imports: [IconModule, InfoDialogContentComponent, ButtonComponent],
  templateUrl: './withdrawal-info-dialog.component.html',
  styleUrl: './withdrawal-info-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WithdrawalInfoDialogComponent {
  readonly #translate = inject(TranslateService);
  readonly #store = inject(WithdrawalStore);
  readonly #toast = inject(GlobalToastService);

  readonly operationId = this.#store.operationId;
  readonly status = this.#store.status;

  readonly vm = computed(() => {
    const status = this.status();
    const errorText = this.#store.errorText();

    const subtitle =
      status === 'failed' && errorText
        ? this.#translate.instant(
            `withdrawal.status.${status}.subtitleWithError`,
            { errorText },
          )
        : this.#translate.instant(`withdrawal.status.${status}.subtitle`);

    return {
      title: this.#translate.instant(`withdrawal.status.${status}.title`),
      subtitle,
      operationId: this.operationId(),
    };
  });

  async onCopy(text: string) {
    await copyToClipboard(text);
    this.#toast.showSuccess(this.#translate.instant('clipboard.copied'));
  }
}
